import { Base64Utils } from "../base64";

export class StringUtils {
	static extractId(str: string): number {
		if (Number.isNaN(Number(str))) {
			const match = str.match(/-(\d+)$/)
			return match ? Number.parseInt(match[1], 10) : 0
		}
		return Number(str)
	}
	static slugify = (value: string) => {
		return value.replace(/ /g, "-")
	}
	static humanReadable = (seconds: number) => {
		const hours = Math.floor(seconds / 3600)
		return `${hours.toString().padStart(2, "0")} giờ`
	}

	static formatDuration(duration: any) {
		if (!duration) return ""
		const timeParts = duration.split(":")
		const hoursCount = Number.parseInt(timeParts[0], 10)
		const minutesCount = Number.parseInt(timeParts[1], 10)

		const formattedParts = []

		if (hoursCount > 0) {
			formattedParts.push(`${hoursCount}h`)
		}

		if (minutesCount > 0) {
			formattedParts.push(`${minutesCount}m`)
		}

		return formattedParts.join(" ")
	}

	static toYoutubeUrl = (url: string) => {
		if (!url) return "";

		try {
			// Try base64 decode first
			const decodedUrl = Base64Utils.decodeWithDefaultKey(url.replace(/\s/g, ''));
			const videoId = decodedUrl.split("/").pop() || "";
			return `youtube/${videoId}`;
		} catch (e) {
			// If base64 decode fails, try to extract video ID directly
			const urlObj = new URL(url);
			let videoId = "";

			if (url.includes("youtu.be")) {
				videoId = urlObj.pathname.slice(1);
			} else if (url.includes("youtube.com")) {
				videoId = urlObj.searchParams.get("v") || "";
			}

			return videoId ? `youtube/${videoId}` : "";
		}
	}
	static toVimeoUrl = (url: string) => {
		if (!url) return "";
		try {
			const decodedUrl = Base64Utils.decodeWithDefaultKey(url.replace(/\s/g, ''));
			const videoId = decodedUrl.split("/").pop() || "";
			return `vimeo/${videoId}`;
		} catch (e) {
			return "";
		}
	}
	static convertToSlug(text: string): string {
		return text
			.toLowerCase()
			.replace(/đ/g, "d")
			.replace(/[áàảãạâấầẩẫậăắằẳẵặ]/g, "a")
			.replace(/[éèẻẽẹêếềểễệ]/g, "e")
			.replace(/[íìỉĩị]/g, "i")
			.replace(/[óòỏõọôốồổỗộơớờởỡợ]/g, "o")
			.replace(/[úùủũụưứừửữự]/g, "u")
			.replace(/[ýỳỷỹỵ]/g, "y")
			.replace(/\s+/g, "-")
			.replace(/[^\w\-]+/g, "")
			.replace(/\-\-+/g, "-")
			.replace(/^-+/, "")
			.replace(/-+$/, "")
	}
	static getYoutubeThumbnail = (url: string): string => {
		const videoId = url.match(
			/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i
		)?.[1] || url;
		return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
	}
}